<template>
    <div class="topbar-container">
        <div class="scrollbar-container">
            <div class="container" v-html="data"></div>
        </div>
    </div>
</template>
<script>
import cache from "@/utils/cache";
import { routeCache } from "@/mixin/cache";
export default {
    mixins: [routeCache],
    name: "DealInfo",
    data() {
        return {
            data: null
        };
    },
    created: function() {
        const me = this,
            params = me.getCache();
        // console.log(params);
        me.$store.state.topBarTitle = params.title;
        cache.getJson(`./json/${params.data}.json`, params.data).then(data => {
            this.data = data.data;
        });
    }
};
</script>
<style scoped lang="scss">
.scrollbar-container {
    background-color: #ffffff;
    .container {
        padding: 20px;
    }
}
</style>
